import * as React from "react";
import "./index.less";
import { DownOutlined } from "@ant-design/icons";
import { Menu, Dropdown, Button } from "antd";

import { pool_uuid, project, headerMenu, allowLocales } from "@/config.json";
import API from "@/apis";
import MyIcon from "@/components/MyIcon";
import { SessionStore, LocaleStore, RouterStore } from "@/stores";
import { inject, observer } from "mobx-react";

const { SubMenu } = Menu;
interface HeaderProps {
  session: SessionStore;
  router: RouterStore;
  locale: LocaleStore;
}

interface CommonHeaderProp {
  type?: any; //未登录为login 观察者为observer
}

interface Props extends HeaderProps, CommonHeaderProp {}

const HELP_CENTER = {
  ZH: "https://support.mempool.com/hc/zh-cn",
  EN: "https://support.mempool.com/hc/en-us",
};

@inject("session", "locale", "router")
@observer
class Header extends React.Component<Props, any> {
  constructor(props) {
    super(props);
  }

  state = {};

  componentDidMount() {
    this.props.session.setSelectMenu(location.pathname.split("/")[1]);
  }

  // selectmenu = e => {
  //   console.log(e);
  //   this.setState({
  //     selectModel: e.key
  //   });
  // };
  /**
   * 用户退出
   * @method logout
   */
  logout = async () => {
    try {
      await API.User.logout();
      this.props.session.userLogout();
      localStorage.removeItem("token");
      localStorage.removeItem("currentSubAcount");
      location.href = "/home?redirect=no";
    } catch (error) {}
  };

  handleChangeLocale = async (value) => {
    let { locale } = this.props;
    // console.log(localStorage.getItem("token"));
    if (localStorage.getItem("token")) {
      try {
        const { data } = await API.Open.setLanguage({ language: value });
        locale.setLocales(value);
      } catch (error) {}
    } else {
      locale.setLocales(value);
    }
  };

  turnToIndex = () => {
    this.props.session.setSelectMenu("/");
    this.props.router.push("/");
  };

  changeMenu = (e) => {
    var key = e.key;
    key == "help" ? null : this.props.session.setSelectMenu(key);
    const defaultHelp = HELP_CENTER[this.props.locale.getLangType]
      ? HELP_CENTER[this.props.locale.getLangType]
      : HELP_CENTER.EN;
    if (key == "help") {
      window.open(defaultHelp);
      return;
    } else if (key == "observer") {
      this.props.router.push(`/${key}`);
      return;
    } else if (key == "item_5") {
      return;
    } else if (key == "dashboard") {
      this.props.router.push(`/`);
      return;
    }
    this.props.router.push(`/${key}`);
  };

  render() {
    const { session, locale, type, router } = this.props;
    const { userinfo, isObservable, isWatcherTheme } = session;

    const userMenu = (
      <Menu>
        <Menu.Item
          className="mempool-header-subMenuItem"
          key="setting"
          onClick={() => {
            this.props.router.push("/settings");
          }}
        >
          {locale.get("Header.dropdown.set")}
        </Menu.Item>
        <Menu.Item className="mempool-header-subMenuItem" onClick={this.logout} key="logout">
          {locale.get("Header.dropdown.exit")}
        </Menu.Item>
      </Menu>
    );
    const languageMenu = (
      <Menu>
        {allowLocales.map((lang, index) => {
          let currentLang = `global.${lang.toLowerCase()}`;
          return (
            <Menu.Item
              key={lang}
              onClick={() => this.handleChangeLocale(lang)}
              className="mempool-header-body-container-right-language-item"
            >
              <MyIcon
                type={`icon-language-${lang.toLowerCase()}`}
                className="mempool-header-body-container-right-language-item-img"
              />
              <span>{locale.get(currentLang as any)}</span>
            </Menu.Item>
          );
        })}
      </Menu>
    );

    return (
      <div className={`mempool-header ${isWatcherTheme && "mempool-header-watcher"}`}>
        <div className="body">
          <div className="body-container">
            {session.signed ? (
              <div className="body-container-left">
                <MyIcon
                  type={`icon-${project}`}
                  className="body-container-left-logo"
                  // onClick={() => this.props.router.push("/home")}
                />

                {!isWatcherTheme ? (
                  <Menu
                    mode="horizontal"
                    selectedKeys={[this.props.session.selectMenu]}
                    onClick={this.changeMenu}
                    className="mempool-header-menu"
                  >
                    <Menu.Item className="menuItem" key="dashboard">
                      {locale.get("Header.Dashboard")}
                    </Menu.Item>
                    <Menu.Item className="menuItem" key="fund">
                      {locale.get("Header.Money")}
                    </Menu.Item>
                    {userinfo.is_pool_account == 1 ? (
                      <Menu.Item className="menuItem" key="treasury">
                        {locale.get("Header.ShareFees")}
                      </Menu.Item>
                    ) : null}
                    {isObservable ? (
                      <Menu.Item key="observer" className="menuItem">
                        {locale.get("Header.Watcher")}
                      </Menu.Item>
                    ) : null}
                    {/* {headerMenu.enableHelpCenter ? (
                      <Menu.Item className="menuItem" key="help">
                        {locale.get("Footer.Help")}
                      </Menu.Item>
                    ) : null} */}
                    <SubMenu
                      className="menuItem"
                      onTitleClick={this.changeMenu}
                      key="group"
                      title={
                        <div>
                          {locale.get("Header.More")}
                          <DownOutlined />
                        </div>
                      }
                    >
                      {headerMenu.subMenu.enableTools ? (
                        <Menu.Item key="tool" className="mempool-header-subMenuItem">
                          {locale.get("Header.Tools")}
                        </Menu.Item>
                      ) : null}
                      <Menu.Item key="report" className="mempool-header-subMenuItem">
                        {locale.get("Header.Report")}
                      </Menu.Item>
                      {userinfo.user_role == 1 ? null : (
                        <Menu.Item key="createAgent" className="mempool-header-subMenuItem">
                          {locale.get("Header.AgentCreate")}
                        </Menu.Item>
                      )}
                      {userinfo.user_role == 1 ? null : (
                        <Menu.Item key="agentManagement" className="mempool-header-subMenuItem">
                          {locale.get("Header.AgentManagement")}
                        </Menu.Item>
                      )}
                    </SubMenu>
                  </Menu>
                ) : null}
              </div>
            ) : (
              <div className="body-container-left">
                <MyIcon
                  type={`icon-${project}`}
                  className="body-container-left-logo"
                  onClick={() => router.push("/home")}
                />
              </div>
            )}
            <div className="body-container-right">
              {session.signed ? (
                <Dropdown overlay={userMenu}>
                  <div className="body-container-right-user">
                    {session.userinfo.email && session.userinfo.mobile
                      ? `${session.userinfo.email} | ${session.userinfo.mobile}`
                      : `${session.userinfo.email || session.userinfo.mobile}`}
                    <DownOutlined />
                  </div>
                </Dropdown>
              ) : isWatcherTheme ? (
                headerMenu.watcher.enableTools ? (
                  <Menu mode="horizontal">
                    <Menu.Item
                      key="moreTool"
                      className={`mempool-header-subMenuItem ${isWatcherTheme && "watcher"} `}
                      onClick={this.changeMenu}
                    >
                      {locale.get("Header.Tools")}
                    </Menu.Item>
                  </Menu>
                ) : null
              ) : null}
              {/* 登录注册 */}
              {!session.signed ? (
                <>
                  <Button type="link" ghost onClick={() => router.push("/login")}>
                    {locale.get("login")}
                  </Button>
                  {/* <Button
                    ghost
                    onClick={() => router.push("/register")}
                    style={{ margin: "0 20px", width: "80px" }}
                  >
                    {locale.get("register")}
                  </Button> */}
                </>
              ) : null}
              <Dropdown overlay={languageMenu}>
                <MyIcon
                  type={`icon-language-${locale.getLangTypeLowerCase}-circle`}
                  className="body-container-right-language"
                />
              </Dropdown>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Header as React.ComponentType<CommonHeaderProp>;
